<template>
<!-- 设备管理共享二维码 -->
    <div class="shareQRcode">
        <!-- <div>
            <p>
                <span>共享次数:</span>
                <span>{{shareTimes}}次</span>
            </p>
            <p>
                <span>获得积分:</span>
                <span>{{getIntegral}}分</span>
            </p>
        </div> -->
        <div class="QRcode">
            <img class="QRcodeImg" :src="QRcode">
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
    props: {

    },
    data() {
        return {
            shareTimes: 4,
            getIntegral: 100,
            QRcode: '',
        };
    },
    computed: {

    },
    created() {
        this.getQRcode()
    },
    mounted() {
    },
    watch: {

    },
    methods: {
        getQRcode() {
            // console.log()
            this.axios.get('/weixin/get2barCode',{
                params: {
                    instrumentId : this.$route.params.instrumentId
                }
            })
            .then(res=>{
                this.QRcode = res.data.url
            })
        },

    },
    components: {

    },
};
</script>

<style scoped>
.shareQRcode {
    padding: 52px;
}
.shareQRcode p {
    display: inline-block;
    width: 48%;
}
.shareQRcode p:last-child {
    text-align: right;
}

.shareQRcode .QRcode {
    width: 494px;
    height: 494px;
    margin: 100px auto;
}
.QRcodeImg {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/ShareQRcode.vue